// @flow
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { get } from "../common/fetch";
import { News } from "./Item";
import { fontSize } from "../common/styled-mixins";
import { NewsLink } from "../common/Link";
import Money from "../Money";
import { AdviceIcon } from "../AccountType/Icons";
import Gettext from "../common/Gettext";

const Advice = styled(News)``;

const TitleIcon = styled.div`
  margin-right: 10px;
  flex: 0 0 auto;
  color: #bebebe;
`;

const Title = styled.div`
  font-size: ${fontSize(12)};
  margin-bottom: 17px;
  color: #919191;
  text-transform: uppercase;
  font-weight: 700;
  display: flex;
  align-items: center;
`;

const Text = styled.div`
  font-size: ${fontSize(14)};
  color: #343434;
  font-weight: 700;
  margin-bottom: 16px;
`;

const Info = styled.div`
  font-size: ${fontSize(14)};
  color: #3b9478;
  font-weight: 700;
  margin-bottom: 11px;
`;

const Link = styled(NewsLink)`
  color: #0085eb;
  font-size: ${fontSize(12)};
  text-transform: lowercase;
`;

const ItemAdvice = () => {
  const [money, setMoney] = useState(null);

  useEffect(() => {
    get("/api/features/list").then((list) => {
      list.payload &&
        list.payload.forEach((item) => {
          if (item.name === "participation_fee") {
            setMoney(item.info.participation_fee);
          }
        });
    });
  }, []);

  if (money == null) {
    return null;
  }

  return (
    <Advice>
      <Title>
        <TitleIcon>
          <AdviceIcon />
        </TitleIcon>
        <Gettext>Advice</Gettext>
      </Title>
      <Text>
        <Gettext>Don't know what to do with your DEMO money?</Gettext>{" "}
        <Gettext>And we know!</Gettext>
      </Text>
      <Info>
        <Gettext>
          Earn {<Money>{money}</Money>} and get a paid tournament invitation!
        </Gettext>
      </Info>
      <Link to="/doubleup" target="_blank">
        <Gettext>Details</Gettext>
      </Link>
    </Advice>
  );
};

export default ItemAdvice;



// WEBPACK FOOTER //
// ./src/components/Bell/ItemAdvice.js